import { DecimalRoundTypeEnum } from '../../constants/enums/decimalRoundType';

const cut = (price, decimalsCount) => Math.trunc(price * 10 ** decimalsCount) / 10 ** decimalsCount;
const roundUp = (price, decimalsCount) => Math.ceil(price * 10 ** decimalsCount) / 10 ** decimalsCount;
const round = (price, decimalsCount) => Math.round(price * 10 ** decimalsCount) / 10 ** decimalsCount;

export const decimalPriceRoundFunc = {
  [DecimalRoundTypeEnum.Cut]: cut,
  [DecimalRoundTypeEnum.RoundUp]: roundUp,
  [DecimalRoundTypeEnum.Round]: round,
};

export const getRoundingMethod = (roundTypeConfig) => decimalPriceRoundFunc[roundTypeConfig] || round;
